import { render, staticRenderFns } from "./modalDuplicarDescuentos.vue?vue&type=template&id=40a500c2&"
import script from "./modalDuplicarDescuentos.vue?vue&type=script&lang=js&"
export * from "./modalDuplicarDescuentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports